// extracted by mini-css-extract-plugin
export default {"container":"AdminViewPage_container__LR0U6","content":"AdminViewPage_content__VznGU","comingSoon":"AdminViewPage_comingSoon__lX8LN"};